<template>
  <KernelDialog
    id="override-roles"
    :title="$t('accounts.overrideRoles')"
  >
    <KernelCheckboxGroup
      v-model="selectedRoles"
      :select-all="$t('general.selectAll')"
      :options="availableRoles"
    />

    <KernelButtonGroup>
      <KernelButton
        type="secondary"
        @click="reset()"
      >
        {{ $t('accounts.reset') }}
      </KernelButton>
      <KernelButton
        v-dialog.close
        @click="save()"
      >
        {{ $t('accounts.override') }}
      </KernelButton>
    </KernelButtonGroup>
  </KernelDialog>
</template>

<script setup lang="ts">
import type { EmployeeRole } from '~/models/EmployeeRoles/Roles.enum'
import { EMPLOYEE_ROLES } from '~/models/EmployeeRoles/Roles.enum'

const { idToken } = useAuth()
const { userRoles } = useUser()

const availableRoles = Object.keys(EMPLOYEE_ROLES)

const selectedRoles = ref<EmployeeRole[]>([])

function save() {
  userRoles.value = selectedRoles.value
}

function reset() {
  selectedRoles.value = idToken.value?.claims.userGroups ?? [] as EmployeeRole[]
}

watchEffect(() => {
  selectedRoles.value = userRoles.value
})
</script>
